import { Center, Box, Stack, Flex, Text } from '@chakra-ui/react'
import { ErrorFallback } from '@components/Fallback'
import { UsageDateRange } from '@features/usage/components/DatePickers/UsageDateRange'
import { ProjectSessionsUsageDetails } from '@features/usage/components/sessions/ProjectSessionsUsageDetails'
import { UsageTabbedNav } from '@features/usage/components/UsageTabbedNav'
import { FallbackRender, ErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { paginationRequestSchema } from '@customTypes/cloudmix/api'
import { withListHydration } from '@lib/listState/withListHydration'

const fallback: FallbackRender = (props) => (
  <ErrorFallback {...props}>
    <Text>
      We're unable to display your Sessions usage, if the problem persists
      contact the Cloudmix team
    </Text>
  </ErrorFallback>
)

const SessionUsageRoute = () => (
  <Center>
    <Box w={'full'} h={'full'} maxW={'5xl'}>
      <UsageTabbedNav />
      <Stack py={4} spacing={6}>
        <Flex justify={'space-around'}>
          <Box w={'full'} maxW={'lg'}>
            <UsageDateRange />
          </Box>
        </Flex>
        <Center>
          <ErrorBoundary fallback={fallback}>
            <ProjectSessionsUsageDetails />
          </ErrorBoundary>
        </Center>
      </Stack>
    </Box>
  </Center>
)

const routerSchema = paginationRequestSchema.partial().catch({})
const routeId = '/_auth/o/$orgId/usage/sessions' as const

export const Route = createFileRoute(routeId)({
  component: SessionUsageRoute,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: { routeId },
    getTitle: () => 'Session Usage',
  }),
})
